import { Box } from "devextreme-react";
import { Item } from "devextreme-react/box";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ProjectListComponent from "./ProjectListComponent";
import SchedulerComponent from "./SchedulerComponent";
import axios from "axios";

export default function WorkRecordWrapper() {
  const userInfo = useSelector((state) => state.userInfo);

  const [resourceDataSource, setResourceDataSource] = useState(null);
  // const [currentEmployeeNo, setCurrentEmployeeNo] = useState(
  //   userInfo.employeeNo
  // );
  const [currentEmployee, setCurrentEmployee] = useState({
    employeeNo: userInfo.employeeNo,
    div: userInfo.div,
  });

  const schedulerRef = useRef(null);

  useEffect(async () => {
    try {
      const result = await axios.get(
        // `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg?employeeNo=${currentEmployeeNo}`
        `${process.env.REACT_APP_BECCO_API_URL}/api/contrReg?employeeNo=${currentEmployee.employeeNo}`
      );

      setResourceDataSource(result.data);

      // schedulerRef.current.instance.options(
      //   "resources[0].dataSource",
      //   result.data
      // );
      // schedulerRef.current.instance.repaint();

      // dataGridRef.current.instance.selectAll();
    } catch (error) {
      console.error(error);
    }
    // }, [currentEmployeeNo]);
  }, [currentEmployee.employeeNo]);

  return (
    <React.Fragment>
      {userInfo.employeeNo && (
        <div>
          <Box direction="row" width={"100%"}>
            {(userInfo.div == "CO" ||
              userInfo.div == "DM" ||
              userInfo.div == "SA" ||
              userInfo.div == "MW" ||
              userInfo.div == "CEO") && (
              <Item ratio={0} baseSize={300}>
                <ProjectListComponent
                  resourceDataSource={resourceDataSource}
                  // setResourceDataSource={setResourceDataSource}
                  // currentEmployeeNo={currentEmployeeNo}
                  currentEmployee={currentEmployee}
                  // setCurrentEmployeeNo={setCurrentEmployeeNo}
                  schedulerRef={schedulerRef}
                />
              </Item>
            )}
            <Item ratio={1}>
              {/* <Provider store={store}> */}
              <SchedulerComponent
                resourceDataSource={resourceDataSource}
                // currentEmployeeNo={currentEmployeeNo}
                currentEmployee={currentEmployee}
                // setCurrentEmployeeNo={setCurrentEmployeeNo}
                setCurrentEmployee={setCurrentEmployee}
                schedulerRef={schedulerRef}
              />
              {/* </Provider> */}
            </Item>
          </Box>
        </div>
      )}
    </React.Fragment>
  );
}
